import { render, staticRenderFns } from "./JuridicoIcon.vue?vue&type=template&id=f734dac2&"
import script from "./JuridicoIcon.vue?vue&type=script&lang=ts&"
export * from "./JuridicoIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports